import React, { useState } from 'react'
import { Captcha } from '/components/Captcha/'
import { Codes } from '/components/Codes/'
import { Countdown } from '/components/Countdown/'
import { message } from 'antd'

export const CaptchaValidation = ({ pin, deliveryBundleStatus }) =>
  (() => {
    const [step, setStep] = useState(1)
    const [state, setState] = useState({
      products: [],
      accessToken: '',
    })

    const countdownCallback = () => {
      setStep(3)
    }

    const captchaCallback = ({ verified, fetchedProducts, accessToken }) => {
      if (!verified) {
        message.error('Ocorreu um erro. Código PIN inválido')
        setStep(1)
      } else {
        setState({ products: fetchedProducts, accessToken })
        setStep(2)
      }
    }

    if (step === 1) {
      return (
        <Captcha
          pin={pin}
          captchaCallback={captchaCallback}
          deliveryBundleStatus={deliveryBundleStatus}
        />
      )
    } else if (step === 2) {
      return <Countdown countdownCallback={countdownCallback} timeLeft={8} />
    } else if (step === 3) {
      return (
        <Codes
          fetchedProducts={state.products}
          pin={pin}
          accessToken={state.accessToken}
        />
      )
    } else {
      return null
    }
  })()
